import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Client } from '../../../shared/client/client';
import { ListLigneCommande } from '../commande';

export interface DialogData {
  lod_ligne_commandes: ListLigneCommande[]
  commandeId: string
  currentClient: Client
}

@Component({
  selector: 'app-commande-edit-send-dialog',
  templateUrl: './commande-edit-send-dialog.component.html',
  styleUrls: ['./commande-edit-send-dialog.component.scss']
})
export class CommandeEditSendDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<CommandeEditSendDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: DialogData,
    private router: Router
  ) { }

  isSending: boolean = false;

  editSendOrder() {
    this.isSending = true;
    this.router.navigate(["/escli/linge-hebergement/edit"], { queryParams: { id: this.data['commande'].id, canEditSend: true } })
    this.dialogRef.close();
    this.isSending = false;
  }

  refuse(): void {
    this.dialogRef.close();
  }
}